<template>
  <div class="radio-component">
    <div
      :class="{ select: index === selectIndex }"
      :key="index"
      v-for="(option, index) in options"
      @click="selectIndex = index"
      class="option-item"
    >
      <div class="text">{{ option.text }}</div>
      <div class="icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuGroupComponent",
  model: {
    prop: "show",
    event: "updateIndex",
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [
          {
            text: "a",
          },
          {
            text: "a",
          },
        ];
      },
    },
    index: {
      // 选中索引
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectIndex: this.index, // 选中索引
    };
  },
  watch: {
    selectIndex(val) {
      this.$emit("updateIndex", val);
    },
    index(val) {
      this.selectIndex = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.radio-component {
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(210, 210, 210, 0.5);
    font-size: 14px;
    font-weight: 600;
    &:last-child {
      border-color: transparent;
    }
    &.select {
      .icon {
        background-image: url("../../../../public/images/login/S_Select@3x.png");
      }
    }
    .icon {
      width: 46px;
      height: 44px;
      background-position: center;
      background-size: contain;
      background-image: url("../../../../public/images/login/S_Normal@3x.png");
    }
  }
}
</style>
